/* 
 * Copyright (C) 2022 SHC Holdings LLC.  All Rights Reserved. 
 */
import React, { useMemo } from 'react';
import {
  SelectedGeographySource,
  PatientChoroplethLayer,
  InfoPopup,
  useMapValue,
  useAPI,
  ImportingLocationLayers,
  MapComponent,
  useFilterValue,
} from 'nmqf-common-ui';
import { IllinoisRegionLayer } from './illinoisregionlayer';
import { extractRegionData } from './illinoisregionlayer/regionpopup';

interface IndexMapComponentProps {
  regions?: string[];
}

export const IndexMapComponent: React.FC<IndexMapComponentProps> = (props) => {
  const [hoveringInfo] = useMapValue('hoveringInfo');
  const [regionData] = useAPI('/api/stats/calculate-statistic-region-overlay', undefined, 'POST');
  const mapStatisticResponsingData = regionData.data?.mapStatisticResponsingData;
  const [statistic] = useFilterValue('statistic', 'statisticOption');

  const regionByGeoCode = useMemo(
    () =>
      Object.entries(mapStatisticResponsingData?.GeoCodesByRegion || {}).reduce((acc, [region, geocodes]) => {
        (geocodes as string[]).forEach((geo) => {
          acc[geo] = region;
        });
        return acc;
      }, Object.assign({})),
    [mapStatisticResponsingData]
  );

  const hoveringRegionName = regionByGeoCode[hoveringInfo?.[0]?.id];
  const isShowRegionPopup = useMemo(() => !!hoveringRegionName && props.regions?.some((v) => v === hoveringRegionName), [hoveringRegionName, props.regions]);

  return (
    <MapComponent>
      <SelectedGeographySource>
        <PatientChoroplethLayer />
        <IllinoisRegionLayer regions={props.regions} />
        <ImportingLocationLayers />
      </SelectedGeographySource>
      <InfoPopup
        region={isShowRegionPopup ? hoveringRegionName : undefined}
        regionData={extractRegionData(statistic, hoveringRegionName, mapStatisticResponsingData)}
      />
    </MapComponent>
  );
};
